import React from 'react';
import { Dialog, DialogContent, IconButton, DialogActions, Button, Typography, Box, Container } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import { useDialogStyles } from 'shared/dialogs/styles';
import { User } from 'entities/Account';
import { PopupsActions } from 'store/reducers/popups';

import { CloseIcon } from 'icons';
import SubscribeButton from 'shared/components/SubscribeButton';

interface PrivateDialogProps {
  open: boolean;
  celebrity?: User | null;
  onClose?: () => void;
}

const PrivateDialog = (props: PrivateDialogProps) => {
  const dispatch = useDispatch();

  const { open, onClose, celebrity } = props;

  const {
    popups: { currentTokenCreatorId },
  } = useSelector((state) => state);

  const celebrityName = celebrity?.name || (celebrity?.nickName && `@${celebrity?.nickName}`);

  const handleClose = () => {
    dispatch(PopupsActions.notEnoughRights(false));
    dispatch(PopupsActions.toggleNoRightsModal(false));
    dispatch(PopupsActions.setCurrentTokenCreatorId(0));
    onClose && onClose();
  };

  const { classes: dialogClasses, cx } = useDialogStyles();

  return (
    <Dialog open={open} onClose={handleClose} className={dialogClasses.privateWrapper}>
      <Container>
        <Box mt={4} mb={4}>
          <IconButton onClick={handleClose} className={dialogClasses.closeBtn} size="large">
            <CloseIcon />
          </IconButton>
          <Box mb={5}>
            <DialogContent className={dialogClasses.content}>
              <Typography variant="h3" className={dialogClasses.privateTitle}>
                Oops! This content is private
              </Typography>
              <Typography variant="subtitle1" className={dialogClasses.privateText}>
                Private content is available only for users with a subscription. <span className={dialogClasses.nameWidthWrapper}>{celebrityName}</span> is adding a rare
                content here, for a close circle. Subscribe to <span className={dialogClasses.nameWidthWrapper}>{celebrityName}’s</span> page to have first access to Rare
                Sales, unique drops, custom content, and many more
              </Typography>
            </DialogContent>
          </Box>
          <DialogActions className={dialogClasses.actions}>
            <Button fullWidth onClick={handleClose} variant="outlined" className={cx(dialogClasses.actionBtn, dialogClasses.actionBtnFullwidth)}>
              Not Now
            </Button>
            <SubscribeButton
              celebrityId={currentTokenCreatorId}
              className={cx(dialogClasses.actionBtn, dialogClasses.actionBtnFullwidth)}
              isContained={true}
              onSubscribe={handleClose}
            />
          </DialogActions>
        </Box>
      </Container>
    </Dialog>
  );
};

export default PrivateDialog;
